export default [
    {
        path: "/pre9810/all",
        name: "Pre9810All",
        component: () => import("@/views/Pre9810/All/index.vue"),
        meta: { activeMenu: "/pre9810/all" },
    },
    {
        path: "/pre9810/draft",
        name: "Pre9810Draft",
        component: () => import("@/views/Pre9810/Draft/index.vue"),
        meta: { activeMenu: "/pre9810/draft" },
    },
    {
        path: "/pre9810/pending",
        name: "Pre9810Pending",
        component: () => import("@/views/Pre9810/Pending/index.vue"),
        meta: { activeMenu: "/pre9810/pending" },
    },
    {
        path: "/pre9810/sent",
        name: "Pre9810Sent",
        component: () => import("@/views/Pre9810/Sent/index.vue"),
        meta: { activeMenu: "/pre9810/sent" },
    },
];
